// Visibility rule for the upper-left Dashboard brain (`.back-button`).
//
// The brain is the app's canonical "home" affordance: fixed top-left, glowing
// on hover/focus, tooltip "Dashboard", navigating to the role's landing path.
// It renders on every in-app route and is suppressed on the public ones
// (login, the password flows, Pantheon, the token-scoped analytics report),
// which deliberately carry no app chrome — a viewer with no session cannot
// follow a link into the dashboard, so offering one would be a dead control.
//
// The Sherloc strategy microsite is the one route that is BOTH public and
// routinely opened by signed-in Cphere users: the backend serves it under
// `optionalAuthenticate`, so the same URL renders for an unauthenticated
// client reading a shared strategy and for the planner who just published it.
// Blanket-excluding it therefore took the brain away from the signed-in case
// too, and that is the omission this rule closes. The split is on the SESSION,
// not on the campaign: any strategy microsite shows the brain to an
// authenticated viewer and none to an anonymous one, so Dark Horse, Never Stop
// Chasing, Knife and every future campaign behave identically.
//
// Kept as a pure module — no route parsing, no router, no DOM — so the rule is
// unit-testable on its own and Cortex and Quantum can pin the identical
// predicate instead of drifting apart in two copies of App.js.

export const shouldShowDashboardBrain = ({
  isExcludedPage = false,
  isCampaignStrategyMicrosite = false,
  isAuthenticated = false,
} = {}) => {
  // Every non-excluded in-app route keeps the brain exactly as before.
  if (!isExcludedPage) return true;
  // Of the excluded (public) routes, only the strategy microsite may show it,
  // and only to a viewer who actually has a session to navigate back into.
  return Boolean(isCampaignStrategyMicrosite) && Boolean(isAuthenticated);
};

export default shouldShowDashboardBrain;
